class _Node {
  constructor(data, next) {
    this.data = data;
    this.next = next;
  }
}

module.exports = _Node;